<template>
  <span
    class="inline-block rounded-full border-2 border-current border-t-transparent opacity-80"
    :style="{ width: `${size}px`, height: `${size}px`, animation: 'pj-spin 0.7s linear infinite' }"
  />
</template>

<script setup lang="ts">
defineProps<{ size?: number }>()
</script>
